import { render, staticRenderFns } from "./AlibeyFlightCatalog.vue?vue&type=template&id=b21b066a&scoped=true"
import script from "./AlibeyFlightCatalog.vue?vue&type=script&lang=js"
export * from "./AlibeyFlightCatalog.vue?vue&type=script&lang=js"
import style0 from "./AlibeyFlightCatalog.vue?vue&type=style&index=0&id=b21b066a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21b066a",
  null
  
)

export default component.exports